// extracted by mini-css-extract-plugin
export default {"title":"vhShhg","text":"RhSA9r"};